import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";

interface CroppingModalProps {
  show: boolean;
  handleClose: () => void;
  image: string;
  imageFile?: File;
  onCrop: (croppedImage: string) => void;
  onCancel?: () => void;
}

const CroppingModal: React.FC<CroppingModalProps> = ({
  show,
  handleClose,
  image,

  onCrop,
  onCancel,
}) => {
  const cropperRef = useRef<ReactCropperElement>(null);
  const [sliderValue, setSliderValue] = useState<number>(100);

  useEffect(() => {
    // const cropper = cropperRef.current
    if (cropperRef.current !== null) {
      // console.log(cropperRef);
      // return;
      const Cropper: any = cropperRef.current?.cropper;
      if (Cropper?.ready === true) {
        console.log(sliderValue);
        Cropper.zoomTo(sliderValue / 100);
      }
      console.log(cropperRef.current?.cropper);
    }
  }, [sliderValue]);

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSliderValue(Number(e.target.value));
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const croppedImage = cropper.getCroppedCanvas().toDataURL();
      onCrop(croppedImage);
      handleClose();
    }
  };

  const handleModalClose = () => {
    if (onCancel) {
      onCancel();
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <Cropper
            ref={cropperRef}
            src={image}
            style={{ height: "400px", width: "100%" }}
            aspectRatio={16 / 9} // Fixed aspect ratio
            guides={false}
            cropBoxResizable={false}
            // zoomTo={}
          />
          <Form.Group>
            <Form.Label>Adjust Cropping Area</Form.Label>
            <Form.Control
              type="range"
              min="50"
              max="200"
              value={sliderValue}
              onChange={handleSliderChange}
            />
          </Form.Group>
        </>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleModalClose}>
          Close
        </Button>
        <Button variant="warning text-white" onClick={handleCrop}>
          Crop Image
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CroppingModal;
